export const CURRENT_SAML_START = 'CURRENT_SAML_START';
export const CURRENT_SAML_SUCCESS = 'CURRENT_SAML_SUCCESS';
export const CURRENT_SAML_FAILURE = 'CURRENT_SAML_FAILURE';

export const CURRENT_SAML_SKIP_START = 'CURRENT_SAML_SKIP_START';
export const CURRENT_SAML_SKIP_SUCCESS = 'CURRENT_SAML_SKIP_SUCCESS';
export const CURRENT_SAML_SKIP_FAILURE = 'CURRENT_SAML_SKIP_FAILURE';

export const FATAL_FAILURE = 'SYSTEM_FAILURE';
